export enum TermsOfServiceStatus {
    DRAFT = 0,
    PUBLISHED = 1,
    ARCHIVED = 2,
}
